import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SeminarManagementOrganizer';

const getListSeminarReducer = handleActions({
    [Actions.GetListSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListSeminarRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const detailSeminarReducer = handleActions({
    [Actions.GetDetailSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailSeminarRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearDetailSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSeminarReducer = handleActions({
    [Actions.UpdateSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
        updateSeminarSuccess: false,
    }),
    [Actions.UpdateSeminarRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        updateSeminarSuccess: true,
    }),
    [Actions.UpdateSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        updateSeminarSuccess: false,
    }),
    [Actions.UpdateSeminarProgess]: (state, action) => ({
        ...state,
        percent: action.payload,
    }),
    [Actions.ClearUpdateSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        percent: 0,
        updateSeminarSuccess: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    updateSeminarSuccess: false,
    percent: 0,
});

export default combineReducers({
    get: getListSeminarReducer,
    detailSeminar: detailSeminarReducer,
    updateSeminar: updateSeminarReducer,
});
